import { render, staticRenderFns } from "./aboutMeView.vue?vue&type=template&id=23647539&scoped=true"
import script from "./aboutMeView.vue?vue&type=script&lang=js"
export * from "./aboutMeView.vue?vue&type=script&lang=js"
import style0 from "./aboutMeView.vue?vue&type=style&index=0&id=23647539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23647539",
  null
  
)

export default component.exports